import {Link} from 'gatsby';
import React from 'react';
import slugify from 'slugify';

function CategoryNav(props) {
  return (
    <ul className={`nav-tabs nav-tabs--tight-h nav-tabs--sm-compact ${props.classes ? props.classes : ''}`}>
      {props.categories.map(category => (
        <li key={category.id}>
          <Link to={`${props.prefix}${slugify(category.categoryTitle, {lower: true})}`} activeClassName="active">{category.categoryTitle}</Link>
        </li>
      ))}
    </ul>
  );
}
export default CategoryNav;